<template lang="pug">
v-container 
  v-card
    v-card-title Empresas
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar empresa' single-line hide-details)
      v-dialog(v-model='dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
                  
          v-menu(v-model='showMenu' absolute offset-y style='max-width: 600px')
            template(v-slot:activator='{ on }')
              v-card
                v-img( height='100' aspect-ratio="2.75" v-on='on' align-end)
                  v-layout(align-end fill-height)
                    v-avatar.mx-2.mb-2.mt-auto(v-if='isNaN(Datos.logoUrl)' :size="140" color="primary"  )
                      v-img( :src='Datos.logoUrl' alt='logo' )
                    v-progress-linear(v-else v-model='Datos.logoUrl') 
            v-list
                ImageInput( title='Subir logo' @getUrl="val => Datos.logoUrl = val")
          v-card-title
            span.headline {{ formTitle }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex
                  v-text-field(v-model='Datos.name' label='Nombre de la empresa')
                v-flex
                  v-text-field(v-model='Datos.apiKey' label='apiKey')
                v-flex
                  v-text-field(v-model='Datos.authDomain' label='authDomain')
                v-flex
                  v-text-field(v-model='Datos.databaseURL' label='databaseURL')
                v-flex
                  v-text-field(v-model='Datos.projectId' label='projectId')
                v-flex
                  v-text-field(v-model='Datos.storageBucket' label='storageBucket')

                
                v-flex(sm12)
                v-flex
                  label Color de la empresa: {{Datos.color}}
                  br
                  input(v-model='Datos.color' type= 'color' placeholder= 'Color de la empresa')
                
          v-card-actions
            v-spacer
            v-btn(color='blue darken-1' @click='close()') Cancelar
            v-btn(color='blue darken-1' @click='add(); dialog = false') Guardar
    v-data-table.elevation-1(:headers='headers' :items=' CustomersRecord' :search='search')
      template(v-slot:item.logoUrl='{item}')
        v-img(:src='item.logoUrl' width='100')
      template(v-slot:item.action='{item}')
        v-btn(color='secondary' icon @click='get(item.key); dialog=true')
          v-icon(small) far fa-edit
        v-btn(color='secondary' icon @click='deleteItem(item.key)')
          v-icon(small) far fa-trash-alt
  v-row.mt-3
    v-btn(@click='getAllPrivileges()' rounded) Obtener todos los privilegios
    v-btn(@click='limpiar_inventarios()' rounded) Limpiar Inventarios
    v-btn(@click='abrir_documentos_de_salida()' rounded) Abrir documentos de salida
    v-btn(@click='abrir_documentos_de_entrada()' rounded) Abrir documentos de entrada
    v-btn(@click='super_funcion()' color='danger' dark rounded) Súper botón 
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import {secondsToFormatDateInput,toSlug} from '@/Helper'
import {storage, db, fb,salesCollection} from '@/FirebaseConfig'
export default {
  data: () => ({
    showMenu: false,
    search: '',
    returnedValue: '',
    value1: '',
    value2: '',
    dialog: false,
    headers: [
      {
        text: 'Lista de Empresas',
        align: 'left',
        value: 'name'
      },
      { text: 'Logo de la empresa', value: 'logoUrl'},
      { text: '', value: 'action'},

    ],
    record: [],
    editedIndex: -1,
    BackgroundFile: null,
    BackgroundURL: null,
    LogoFile: '',
    LogoURL: '',
    datacollection: null,

  }),
    created () {
      this.$store.dispatch('Customers/getAll')
    },

    methods: {
      ...mapActions({
        clearForm: 'Customers/clearForm',
        abrir_documentos_de_entrada: 'Inputs/abrir_documentos',
        abrir_documentos_de_salida: 'Outputs/abrir_documentos',
        limpiar_inventarios: 'Product/limpiar_inventarios',
        getAllPrivileges: 'Users/getAllPrivileges',
        emptyKardex: 'Kardex/emptyKardex',
        processItem: 'Kardex/processItem',
        add: 'Customers/add',
        get: 'Customers/get',
      }),
     
      editItem (key) {
        this.$store.dispatch('Customers/get',key)
        this.dialog = true
      },

      deleteItem (key) {
        this.$store.dispatch('Customers/clean',key)
      },
   
    
      cleanSelectedKey(){
      this.$store.commit('Customers/cleanSelectedKey')
      },

      async super_funcion(){
        try {
          console.log('inicio')
          const colección = await db.collection('app').doc('setting').collection('Products').get()
          const array_a_guardar = []
          colección.docs.map(doc => {
            let nuevo_documento = {...doc.data(), descripcion: doc.data().description }
            console.log(nuevo_documento)
            array_a_guardar.push( db.collection('app').doc('setting').collection('Products').doc(doc.id).update(nuevo_documento) )
          })
          await Promise.all(array_a_guardar)
          console.log('listo')
        } catch (error){
          console.log(error)
        }
      },
    },
    components: {
      ImageInput: ()=>import('.././components/ImageInput'),
      Example: () => import('./example')
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Añadir' : 'Editar'
      },
      CustomersRecord(){
        return this.$store.getters['Customers/record']
      },
      ...mapState({
        Datos: state=>state.Customers.data
      })
    },
  }
  /**
   * 
         let i = item.data()

          let o = {
            cliente_denominacion:'SERVICIOS METAL MECANICOS PERUANOS S.A',
            cliente_direccion:'los Pinos Mza. H Lote. 10 A.H.Virgen de la Puerta',
            cliente_email:'',
            cliente_numero_de_documento:'20601642451',
            cliente_tipo_de_documento:'6',
            creado_el: i.createdAt,
            creado_por:i.createdBy,
            documento_de_operacion:'Nota de salida',
            estado_del_documento:'esperando',
            enviar_automaticamente_a_la_sunat: true,
            enviar_automaticamente_al_cliente: true,
            fecha_de_emision: secondsToFormatDateInput(i.createdAt),
            feha_de_inicio_de_traslado :secondsToFormatDateInput(i.createdAt),
            isClose :i.isClose,
            items:i.items.map(item=>({
              anticipo_documento_numero: '',
              key:item.key,
              anticipo_documento_serie: '',
              nombre_unidad_de_medida:item.measureUnit,
              precio_unitario:'',
              valor_unitario:'',
              cantidad:Number(item.quantity),
              createdAt:item.createdAt, 
              descripcion:item.description,
              igv:'',
              existence:{
                //ALMACEN PRINCIPAL:0,
                TOTAL:item.existence,
              },
            })),
            lugar:i.place || '',
            observaciones:i.reason|| '',
            numero_de_operacion:i.number,
            motivo_de_traslado:'04',
            nombre_motivo_de_traslado:'TRANSFERENCIA ENTRE ALMACENES',
            punto_de_llegada_direccion:' Trujillo Trujillo La Libertad',
            punto_de_partida_direccion:'los Pinos Mza. H Lote. 10 A.H.Virgen de la Puerta',
            punto_de_partida_ubigeo:'130101',
            nombre_de_documento_guia:'Guía de remisión',
            serie_guia:'T001',
            tipo_de_documento_guia:Number('7'),
            total:'',
            total_igv: Number('0'),
            total_gravada : Number('0'),
            total_exonerada : Number('0'),
            total_descuento : Number('0'),
            descuento_global : Number('0'),
            warehouse:[
              { 
                name:'ALMACEN-PRINCIPAL',
                slug:toSlug('ALMACEN-PRINCIPAL')
              }, 
              { 
                name:'ALMACEN-PRINCIPAL',
                slug:toSlug('ALMACEN-PRINCIPAL')
              }
            ]
          }
          o={...o,
         }
         try{
          await db.collection('app').doc('salidas').collection('registro').doc(item.id).set(o)
          
           console.log('ok')
         }catch(error){
           console.log(o)
         }


        })
  */
  /**
   *  #MIGRAR ENTRADAS
   *  async super_funcion(){
        try{
          let index = 0
          const arreglo_a_grabar = []
          console.log('empezando')
          let collection = await db.collection('app').doc('inventory').collection('Inputs')
          .orderBy('number', 'asc').get()
          collection.docs.map(item => {
            let i = item.data()
            let o = {
              proveedor_denominacion: i.supplier.name,
              proveedor_direccion: i.supplier.address,
              proveedor_email: i.supplier.email,
              proveedor_numero_de_documento: i.supplier.document,
              proveedor_tipo_de_documento:'6',
              creado_el: i.createdAt,
              creado_por:i.createdBy,
              documento_de_operacion:'Nota de entrada',
              estado_del_documento:'esperando',
              fecha_de_emision: secondsToFormatDateInput(i.createdAt),
              feha_de_inicio_de_traslado :secondsToFormatDateInput(i.createdAt),
              isClose :i.isClose,
              items:i.items.map(item=>({
                anticipo_documento_numero: '',
                key: item.key,
                anticipo_documento_serie: '',
                nombre_unidad_de_medida: 'NIU',
                precio_unitario: i.incluedIGV ? Number(item.cost) : Number(item.cost) * 1.18,
                valor_unitario: i.incluedIGV ? Number(item.cost) / 1.18 : Number(item.cost),
                cantidad:Number(item.quantity),
                createdAt: item.createdAt, 
                igv: i.incluedIGV ? Number(item.cost) / 1.18 * 0.18 : Number(item.cost) * 0.18,
                descripcion: item.description,
                tipo_de_igv: 1,
                descuento: 0,
              })),
              serie_comprobante: i.receiptNumber ? i.receiptNumber.slice(0, 4) : '',
              numero_comprobante: i.receiptNumber ? i.receiptNumber.slice(4) : '',
              
              nombre_motivo_de_traslado: "COMPRA",
              nombre_de_comprobante: "Factura",
              tipo_de_comprobante: 1,
              lugar: i.place || '',
              observaciones: i.reason|| '',
              numero_de_operacion: i.number,
              motivo_de_traslado: '02',
              nombre_motivo_de_traslado:'COMPRA',
              total_exonerada : Number('0'),
              total_descuento : Number('0'),
              descuento_global : Number('0'),
              warehouse:[
                { 
                  name:'ALMACEN-PRINCIPAL',
                  slug:toSlug('ALMACEN-PRINCIPAL')
                }
              ]
            }
            o={
              ...o,
              items: o.items.map( item => ({...item, valor_unitario: Number(item.valor_unitario.toFixed(2)), igv: Number(item.valor_unitario.toFixed(2)), precio_unitario: Number(item.precio_unitario.toFixed(2)) }) ),
              total: o.items.map( ( {precio_unitario, cantidad} ) => precio_unitario * cantidad ).reduce( (a, b)=> a + b, 0),
              total_gravada: o.items.map( ( {valor_unitario, cantidad} ) => valor_unitario * cantidad ).reduce( (a, b)=> a + b, 0),
              total_igv: o.items.map( ( {igv, cantidad} ) => igv * cantidad ).reduce( (a, b)=> a + b, 0)         
            }
          
            arreglo_a_grabar.push( db.collection('app').doc('entradas').collection('registro').doc(item.id).set(o) )
            console.log(o)
            console.log(item.data().number)
          })
          console.log('espera')
          await Promise.all(arreglo_a_grabar)
          console.log('listo')
        }catch(error){
           console.log(error)
        }     
        
       
      },
   */
  /*
  MIGRAR SALIDAS
       try{
          let index = 0
          const arreglo_a_grabar = []
          console.log( 'empezando' )
          let collection = await db.collection('app').doc('inventory').collection('Outputs')
          .orderBy('number', 'asc')
          .where('number', '>', 575  ).get()
          collection.docs.map(item => {
            let i = item.data()

            let o = {
              cliente_denominacion:'SERVICIOS METAL MECANICOS PERUANOS S.A',
              cliente_direccion:'los Pinos Mza. H Lote. 10 A.H.Virgen de la Puerta',
              cliente_email:'',
              cliente_numero_de_documento:'20601642451',
              cliente_tipo_de_documento:'6',
              creado_el: i.createdAt,
              creado_por:i.createdBy,
              documento_de_operacion:'Nota de salida',
              estado_del_documento:'esperando',
              enviar_automaticamente_a_la_sunat: true,
              enviar_automaticamente_al_cliente: true,
              fecha_de_emision: secondsToFormatDateInput(i.createdAt),
              feha_de_inicio_de_traslado :secondsToFormatDateInput(i.createdAt),
              isClose :i.isClose,
              items:i.items.map(item=>({
                anticipo_documento_numero: '',
                key:item.key,
                anticipo_documento_serie: '',
                nombre_unidad_de_medida:item.measureUnit,
                precio_unitario:'',
                valor_unitario:'',
                cantidad:Number(item.quantity),
                createdAt:item.createdAt, 
                descripcion:item.description,
                igv:Number('0'),
            
              })),
              lugar:i.place || '',
              observaciones:i.reason|| '',
              numero_de_operacion:i.number,
              motivo_de_traslado:'04',
              nombre_motivo_de_traslado:'TRANSFERENCIA ENTRE ALMACENES',
              punto_de_llegada_direccion:' Trujillo Trujillo La Libertad',
              punto_de_partida_direccion:'los Pinos Mza. H Lote. 10 A.H.Virgen de la Puerta',
              punto_de_partida_ubigeo:'130101',
              nombre_de_documento_guia:'Guía de remisión',
              serie_guia:'T001',
              tipo_de_documento_guia:Number('7'),
              total:'',
              total_igv: Number('0'),
              total_gravada : Number('0'),
              total_exonerada : Number('0'),
              total_descuento : Number('0'),
              descuento_global : Number('0'),
              warehouse:[
                { 
                  name:'ALMACEN-PRINCIPAL',
                  slug:toSlug('ALMACEN-PRINCIPAL')
                }, 
                { 
                  name:'ALMACEN-PRINCIPAL',
                  slug:toSlug('ALMACEN-PRINCIPAL')
                }
              ]
            }
            console.log(o)
            arreglo_a_grabar.push(db.collection('app').doc('salidas').collection('registro').doc(item.id).set(o))
          })
          console.log('espera')
          await Promise.all(arreglo_a_grabar)
          console.log('listo')
        }catch(error){
           console.log(error)
        }     
        
       
  */
</script>
<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>